export const SET_AUTHORIZATION = 'SET_AUTHORIZATION';
export const TOKEN = 'token';
export const SET_BEAT = 'SET_BEAT';
